import styled from 'styled-components';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { Spinner } from 'react-bootstrap';

import { theme } from '_constants/theme';
import { ROUTES } from '_constants/routes';
import {
  storeLocalValue,
  restoreLocalValue,
  storeSessionValue,
} from '_helpers/storage';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import * as React from 'react';
import Link from 'next/link';
import Box from '@mui/material/Box';
import { Pagination } from '@mui/material';
import DontWaitBannerSection from 'components/composed/sections/DontWaitBannerSection';
import QuickEasyProcessSection from 'components/composed/sections/QuickEasyProcessSection';
import SearchTrademarkGeniusSection from 'components/composed/sections/SearchTrademarkGeniusSection';
import SearchTrademarkGeniusProcessSection from 'components/composed/sections/SearchTrademarkGeniusProcessSection';
import SearchToUseUSPTOSection from 'components/composed/sections/SearchToUseUSPTOSection';
import SearchTrademarkGeniusGraySection from 'components/composed/sections/SearchTrademarkGeniusGraySection';

const { publicRuntimeConfig } = getConfig();
const { colors, devices, fontSizes, spaces } = theme;

const StyledSearchProcessSection = styled.div`
  width: 100%;
  .home {
    width: 100%;
  }
  .headerSection {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 400;
    font-size: ${fontSizes.large11X}px;
    line-height: 130%;
    text-align: center;
    color: ${colors.gray[800]};
  }

  .subHeaderSection {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 400;
    font-size: ${fontSizes.large}px;
    line-height: 150%;
    text-align: center;
    color: ${colors.gray[700]};
  }

  .columnContainer {
    display: flex;
    justify-content: center;
  }

  .column2 {
    box-sizing: border-box;
    margin-left: ${spaces.large2X - 2}px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    flex-grow: 1;

    padding: ${spaces.large2X - 2}px;
    background: ${colors.white};
    border: 1px solid ${colors.gray[200]};
    border-radius: ${spaces.large2X - 2}px;
    gap: ${spaces.medium}px;

    & > div:first-child {
      width: 100%;
    }

    .processing {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-grow: 1;
      width: 100%;
    }

    .no-results {
      text-align: center;
      margin-bottom: 0px !important;
    }

    .error-message {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      width: 100%;
      overflow-wrap: break-word;
      color: ${colors.orange[800]};
    }

    .resultsHeader {
      font-family: 'Aeonik';
      font-style: normal;
      font-weight: 500;
      font-size: ${fontSizes.large8X}px;
      line-height: 150%;
      text-align: center;
      color: ${colors.blue[600]};
    }

    .resultsDescription {
      display: flex;
      order: 0;
      justify-content: center;
      margin-bottom: ${spaces.medium}px;
      font-family: 'Aeonik';
      font-style: normal;
      font-weight: 400;
      font-size: ${fontSizes.large}px;
      line-height: 150%;
      color: ${colors.gray[500]};

      span {
        color: ${colors.blue[500]};
        display: contents;
      }
    }
  }

  .statusDead {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 56px;
    height: 36px;
    margin-top: ${spaces.small}px;
    margin-bottom: ${spaces.small}px;
    background: ${colors.gray[300]};
    border-radius: 4px;
    flex: none;
    order: 0;
    flex-grow: 1;
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.regular}px;
    line-height: 150%;
    text-align: center;
    color: ${colors.gray[500]};
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .statusLive {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-top: ${spaces.small}px;
    margin-bottom: ${spaces.small}px;
    width: 56px;
    height: 36px;
    background: ${colors.green[100]};
    border-radius: 4px;
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.regular}px;
    line-height: 150%;
    text-align: center;
    color: ${colors.green[500]};
  }

  @media ${devices.tablet} {
    margin-left: 0;
    margin-right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px;
    width: 100%;
    gap: 0px;
    order: 1;
    flex-grow: 0;
    .home {
      width: 100%;
    }
    .columnContainer {
      flex-direction: column;
    }
    .headerSection {
      font-size: ${fontSizes.large2X}px;
      line-height: 150%;
    }
    .subHeaderSection {
      font-size: ${fontSizes.regular}px;
      line-height: 150%;
      margin-top: ${spaces.smallX}px;
    }
    .column1 .container .headerStep {
      font-size: ${fontSizes.large}px;
      line-height: 150%;
    }
    .column1 .container .descriptionStep {
      margin-top: ${spaces.smallX}px;
      font-size: ${fontSizes.regular}px;
      line-height: 150%;
    }
    .column2 {
      margin-left: 0px;
      margin-top: ${spaces.large2X}px;
      border: none;
      padding: 0px;
      gap: ${spaces.medium}px;
      .childrenDescription {
        width: 100%;
        text-align: center;
        font-size: ${fontSizes.regular}px;
      }
      .statusLive,
      .statusDead {
        margin-top: -${spaces.regular}px;
        margin-bottom: -${spaces.regular}px;
      }
    }
    .mobile {
      width: 100%;
    }
    .no-results {
      border: 1px solid ${colors.gray[200]};
      border-radius: ${spaces.large2X - 2}px;
      padding-bottom: ${spaces.large2X - 2}px;
    }
  }
`;

const SearchProcessSectionWithoutResult = ({
  loading,
  error,
  items,
  search,
  setSearch,
  page,
  setPage,
  handleChange,
  path,
  elRef,
}) => {
  const router = useRouter();

  const handlePageChange = (event, value) => {
    setPage(value);
  };
  function handleSearch(item) {
    storeSessionValue(
      'searchResult',
      items.elements?.filter((x) => x.id === item)[0]
    );
    router.push({
      pathname: '/searchDetails',
      query: { id: item },
    });
  }
  return (
    <StyledSearchProcessSection>
      <div className="home search">
        <div className="top-banner">
          <div className="copy">
            <h1>
              File Your Trademark Online.
              <br />
              Official USPTO Registration process.
              <br />
              Protect Your Brand Today.
            </h1>
            <input
              type="text"
              placeholder="Search trademark availability"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  handleChange();
                }
              }}
              data-hj-allow
            />
            <Typography
              className="orange-btn"
              onClick={handleChange}
              style={{ cursor: 'pointer' }}
            >
              Search
            </Typography>
            <Typography className="bottom">
              Already know your Trademark is available?
            </Typography>
            <Typography
              className="orange-btn"
              style={{
                cursor: 'pointer',
                maxWidth: 'fit-content',
                marginTop: '1em',
              }}
              onClick={() => router.push(path)}
            >
              Start Registering Now
            </Typography>
          </div>
        </div>
      </div>
      {!items?.elements && (
        <>
          <SearchToUseUSPTOSection />
          <SearchTrademarkGeniusProcessSection />
          <SearchTrademarkGeniusGraySection />
          <SearchTrademarkGeniusSection />
          <DontWaitBannerSection link={path} />
        </>
      )}
      {!loading && !error && items?.elements && items?.elements.length > 0 && (
        <>
          <QuickEasyProcessSection />
          <div className="table-results" ref={elRef}>
            <div className="wrapper">
              <div className="sort-by">
                <Box></Box>
                <h5 style={{ float: 'right' }}>
                  Displaying mark{' '}
                  <span>
                    {items.maxPerPage * (items.page - 1) + 1} –{' '}
                    {items.maxPerPage * (items.page - 1) +
                      items.elements.length}
                  </span>{' '}
                  of <span>{items.totalResults}</span> in total
                </h5>
              </div>
              <table className="desktop">
                <thead>
                  <tr className="header">
                    <th>trademark</th>
                    <th>owner</th>
                    <th>Serial Number</th>
                    <th>filing date</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  {items.elements.map(
                    (
                      item //here we map through the items
                    ) => (
                      <tr key={item.id}>
                        <td className="title">
                          <Typography
                            style={{
                              fontFamily: 'MontserratBold',
                              fontSize: '14px',
                              cursor: 'pointer',
                            }}
                            onClick={() => handleSearch(item.id)}
                          >
                            {item.markIdentification}
                          </Typography>
                        </td>
                        <td className="owner">
                          {item.owners ? item.owners[0]?.partyName : ''}
                        </td>
                        <td>{item.serialNumber}</td>
                        <td>{item.filingDate}</td>
                        <td
                          className={
                            item.liveOrDeadStatus === 'Live'
                              ? 'status live'
                              : 'status dead'
                          }
                        ></td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
              <table className="mobile">
                <tbody>
                  {items.elements.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <div className="title">
                          <Typography
                            style={{
                              fontFamily: 'MontserratBold',
                              fontSize: '14px',
                              cursor: 'pointer',
                            }}
                            onClick={() => handleSearch(item.id)}
                          >
                            {item.markIdentification}
                          </Typography>
                        </div>
                        <div className="owner">
                          {item.owners ? item.owners[0]?.partyName : ''}
                        </div>
                        <div className="one-line">
                          <div className="filing-date">{item.filingDate}</div>
                          <div
                            className={
                              item.liveOrDeadStatus === 'Live'
                                ? 'status live'
                                : 'status dead'
                            }
                          ></div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="paging">
                <div className="wrapper">
                  <Pagination
                    count={items.totalPages}
                    page={parseInt(page)}
                    onChange={handlePageChange}
                    siblingCount={0}
                  />
                </div>
              </div>
            </div>
            <div className="search-price sides">
              <div className="side-box-wrapper">
                <div className="side-box-back-2"></div>
                <div className="side-box-back"></div>
                <div
                  className="side-box"
                  style={{ marginTop: '25px', marginBottom: '30px' }}
                >
                  <div className="header-line"></div>
                  <h4>Start Your Trademark Registration</h4>
                  <div
                    className="orange-box"
                    style={{ cursor: 'pointer' }}
                    onClick={() => router.push(path)}
                  >
                    <div className="star"></div>
                    <div className="price-wrapper">
                      <div className="price">$99.00</div>
                      <p>+ USPTO gov fees</p>
                    </div>
                    <div className="star"></div>
                  </div>
                  <ul>
                    <li>
                      <span></span>
                      <p>
                        Professional assembly, formatting and review done by
                        specialists
                      </p>
                    </li>
                    <li>
                      <span></span>
                      <p>Electronic delivery and transparent updates</p>
                    </li>
                    <li>
                      <span></span>
                      <p>All information secured and organized in one place</p>
                    </li>
                  </ul>
                  <Link href={path}>
                    <Button>Start Registering</Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {!loading && error && (
        <div className="error-message">{error?.message}</div>
      )}
      {loading && (
        <div className="processing">
          <Spinner animation="border" variant="secondary" />
        </div>
      )}
    </StyledSearchProcessSection>
  );
};

export default SearchProcessSectionWithoutResult;
